var map = {
	"./1.jpg": 790,
	"./10.jpg": 791,
	"./11.jpg": 792,
	"./12.jpg": 793,
	"./13.jpg": 794,
	"./14.jpg": 795,
	"./15.jpg": 796,
	"./16.jpg": 797,
	"./17.jpg": 798,
	"./18.jpg": 799,
	"./19.jpg": 800,
	"./2.jpg": 801,
	"./20.jpg": 802,
	"./21.jpg": 803,
	"./3.jpg": 804,
	"./4.jpg": 805,
	"./5.jpg": 806,
	"./6.jpg": 807,
	"./7.jpg": 808,
	"./8.jpg": 809,
	"./9.jpg": 810
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 789;